export default __webpack_public_path__ + "static/media/toma_turno_logo.3a7ffc81.svg";